import {
  LicensesApi,
  ControlcenterMelcoModelsSerialNumberHistory,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
// Show all the data in History Table
// const activatedOrDeactivated = (
//   item: ControlcenterMelcoModelsSerialNumberHistory
// ) => {
//   const { history_type } = item;

//   const activated = history_type === 6; // VIRTUAL_LOGIN
//   const deactivated = history_type === 7; // VIRTUAL_LOGOUT

//   return activated || deactivated;
// };

export const useLicenseHistory = (licenseId: string | undefined) => {
  const { onTableConfigChange, setTotal } =
    useTable<ControlcenterMelcoModelsSerialNumberHistory>();

  const query = useAPIQuery(
    LicensesApi,
    ["licenseHistory", licenseId],
    async (api) => {
      if (licenseId == null) {
        return [];
      }

      // const api = new LicensesApi(
      //   baseApiConfig({ token })
      // );

      const { list } = await api.getHistoryBySerialNumber({
        serialNumber: licenseId,
      });

      //const historyItems = list.filter(activatedOrDeactivated);
      //setTotal(historyItems.length);
      /** No Sorting in Front End */
      // return orderBy(list, ["created_date"], ["desc"]);
      return list;
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    setTotal,
    errorComponent,
    ...query,
  };
};
